import {createEventEmitter} from "../../../../react/event";

export const VerbEvent = createEventEmitter();
